import { Component } from "react"

/* Components */
import { Input } from "../../components"

/* Modal */
import Modal from "react-modal"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"

/* REST API */
import { create, edit } from "../../api/Studio"

/* Helpers */
import { utils } from "../../helpers"

/* Icons */
import { LoadingOutlined } from "@ant-design/icons"

/* Sweet alert */
import Swal from "sweetalert2"


/* Widget Studio Container */
class StudioContainer extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
            type: "",
            id: 0,
            name: "",
            slug: "",
            serviceURL: "",
            socketURL: "",
            recordURL: "",
            waiting: false,
        }
    }

    /* Open */
    open = ({ id, type, name, slug, serviceURL, socketURL, recordURL }) => {
        this.setState({
            visible: true,
            id: utils.checkValue(id, 0),
            type: utils.checkValue(type, ""),
            name: utils.checkValue(name, ""),
            slug: utils.checkValue(slug, ""),
            serviceURL: utils.checkValue(serviceURL, ""),
            socketURL: utils.checkValue(socketURL, ""),
            recordURL: utils.checkValue(recordURL, ""),
            waiting: false,
        })
    }

    /* Close Action */
    close = () => {
        this.setState({ visible: false, id: 0, type: "", name: "", slug: "", serviceURL: "", socketURL: "", recordURL: "", waiting: false })
    }

    /* Save Action */
    save = () => {

        /* Fields */
        const { id, type, name, slug, serviceURL, socketURL, recordURL } = this.state
        const { reload } = this.props

        /* Check Name */
        if (!name) {
            this._name.error(t("studio.error.emptyName"))
            return
        }

        /* Check Slug */
        if (!slug) {
            this._slug.error(t("studio.error.emptyCode"))
            return
        }

        /* Check Service URL */
        if (!serviceURL) {
            this._serviceURL.error(t("studio.error.emptyServiceURL"))
            return
        }

        /* Check Socket URL */
        if (!socketURL) {
            this._socketURL.error(t("studio.error.emptySocketURL"))
            return
        }

        /* Start Waiting */
        this.setState({ waiting: true })

        /* Create */
        if (type === "create") {

            /* Send to REST API */
            create({ name, slug, serviceURL, socketURL, recordURL }).then((response) => {
                if (response.status === 200) {
                    Swal.fire(utils.notification(t("studio.createdSuccess"), "success"))
                }
                else {
                    Swal.fire(utils.notification(t("widget.somethingWrong"), "error"))
                }
            }).catch(() => {
                Swal.fire(utils.notification(t("widget.somethingWrong"), "error"))
            }).finally(() => {
                reload()
                this.close()
            })

        }

        /* Edit */
        if (type === "edit") {

            /* Send to REST API */
            edit({ id, name, slug, serviceURL, socketURL, recordURL }).then((response) => {
                if (response.status === 200) {
                    Swal.fire(utils.notification(t("studio.savedSuccess"), "success"))
                }
                else {
                    Swal.fire(utils.notification(t("widget.somethingWrong"), "error"))
                }
            }).catch(() => {
                Swal.fire(utils.notification(t("widget.somethingWrong"), "error"))
            }).finally(() => {
                reload()
                this.close()
            })

        }

    }

    /* Draw button */
    _button = () => {

        /* Fields */
        const { waiting } = this.state

        /* Waiting */
        if (waiting) {
            return <div className="studio--modal-button"><LoadingOutlined /></div>
        }

        return <div onClick={() => this.save()} className="studio--modal-button">{t("common.save")}</div>
    }

    render = () => {

        /* Fields */
        const { visible, type, name, slug, serviceURL, socketURL, recordURL } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={() => this.close()}
                className="studio--modal"
                overlayClassName="studio--overlay"
                closeTimeoutMS={200}
            >

                <div className="studio--modal-header">
                    <h2>{type === "create" ? t("studio.createdTitle") : t("studio.editTitle")}</h2>
                    <div onClick={() => this.close()} className="studio--modal-close">
                        <img src="/images/close.png" alt="Close" />
                    </div>
                </div>

                <div className="studio--modal-form">
                    <Input ref={(ref) => this._name = ref} label={t("studio.nameLabel")} value={name} onChange={(event) => this.setState({ name: event.target.value })} />
                    <Input ref={(ref) => this._slug = ref} label={t("studio.codeLabel")} value={slug} onChange={(event) => this.setState({ slug: event.target.value })} />
                    <Input ref={(ref) => this._serviceURL = ref} label="Service URL" value={serviceURL} onChange={(event) => this.setState({ serviceURL: event.target.value })} />
                    <Input ref={(ref) => this._socketURL = ref} label="Socket URL" value={socketURL} onChange={(event) => this.setState({ socketURL: event.target.value })} />
                    <Input ref={(ref) => this._recordURL = ref} label="Record URL" value={recordURL} onChange={(event) => this.setState({ recordURL: event.target.value })} />
                    {this._button()}
                </div>

            </Modal>
        )
    }
}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps, null, null, { forwardRef: true })(StudioContainer)